export const TIMEOUT = 300;
export const MAXIMUM_TAB_ID = 100_000;
export const CHANNEL_NAME = 'rango-widget';
